<script>
import EmailPacket from './components/EmailPacket';

import './index.css';

export default {
  name: 'email-active-packets',
  components: {
    EmailPacket
  },
  props: {
    packets: Array
  }
};
</script>

<template>
  <div class="email-active-packets">
    <div class="email-active-packets__label">{{ $t('fe.tariffs.email.active.packages') | capitalize }}</div>
    <div class="email-active-packets__items">
      <div v-if="!packets.length" class="email-active-packets__no-packets">
        {{ $t('fe.tariffs.email.no.active.packets') | capitalize }}
      </div>
      <email-packet
        :key="companyPacketId"
        :endDate="endDate"
        :balance="balance"
        :quantity="quantity"
        :startDate="startDate"
        :packetLocalName="packetLocalName"
        v-for="{ endDate, balance, quantity, startDate, packetLocalName, companyPacketId } in packets"
        v-else
      />
    </div>
  </div>
</template>
